
	import { Component, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';

	@Component({
		components: { ViewportWrapper }
	})
	export default class TheContentTitle extends Vue {
		protected get label(): string {
			const treeContext = aps.navigation.tree?.context || [];

			return treeContext[treeContext.length - 1]?.viewLabel || '';
		}

		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			const { isVue, popup } = aps.context._view;
			const isWizardActive = aps.wizard.active;
			const showBottomPadding = !isVue && !popup && !isWizardActive;

			return {
				paddingBottom: showBottomPadding ? '24px' : '0'
			};
		}
	}
